import React from "react";
import { useFieldArray } from "react-hook-form";
import {ReactHookFormSelect} from "../../nuup/componentes/Forms/ReactHookFormSelect.jsx";
import {ReactHookFormInput} from "../../nuup/componentes/Forms/ReactHookFormInput.jsx";
import { colors } from "@mui/material";
import { calcPorcentajeZaranda } from "./components/calidad-calculos.js";

const CalidadAnalisisFisicoZarandas = ({ control, register, setValue, getValues, errors, onBlurRecalc }) => {

  const { fields, append, remove, insert } = useFieldArray({
    control,
    name: "analisis_oro.zarandas",
  });

  const agregaZaranda = () => {
    append({
      id_calidad_analisis_fisicos_zaranda: 0,
      id_zaranda: 0,
      valor: "",
      eliminar: 0,
    });
  };


  const eliminaZaranda = (index) => {
    // Siempre remover del arreglo para que no se envíe al servidor
    remove(index);
  }


  return (
    <div>
        <div className="row mt-3">
          <div className="col-lg-12">
            <span style={{fontSize : 14,fontWeight : 'bold'}}>{"Zarandas / Criba"}</span>
          </div>
        </div>

        {fields.map((zaranda, index) => (
        <div key={index} style={{marginTop : 10}}>
        <div className={'row'}>
          <div className="col-lg-12">
            <div className="row">
              <div className="col-xs-12 col-lg-4 mt-2">
                <ReactHookFormSelect
                  placeholder="Tamaño"
                  label="Tamaño"
                  id={`analisis_oro.zarandas[${index}].id_zaranda`}
                  name={`analisis_oro.zarandas[${index}].id_zaranda`}
                  error={errors?.analisis_oro?.zarandas?.[index]?.id_zaranda ? true : false}
                  url={"calidad/catalogos/zarandas"}
                  keyArray="id"
                  labelArray="nombre"
                  value={getValues()?.analisis_oro?.zarandas?.[index]?.id_zaranda}
                  control={control}
                  apiSearch={false}
                />
                {errors?.analisis_oro?.zarandas?.[index]?.id_zaranda && (
                  <div className="invalid-feedback">
                    {errors?.analisis_oro?.zarandas?.[index]?.id_zaranda.message}
                  </div>
                )}
              </div>
              <div className="col-xs-10 col-lg-3 mt-2">
              <ReactHookFormInput
                type="number"
                id={`analisis_oro.zarandas[${index}].valor`}
                name={`analisis_oro.zarandas[${index}].valor`}
                error={errors?.analisis_oro?.zarandas?.[index]?.valor}
                label="Valor (grs.)"
                control={control}
                value={getValues()?.analisis_oro?.zarandas?.[index]?.valor}
                onBlurExternal={typeof onBlurRecalc === 'function' ? onBlurRecalc : undefined}
              />
              </div>
              <div className="col-xs-12 col-lg-3 mt-4">
                {(() => {
                  const pesoMuestraOro = Number(getValues()?.analisis_oro?.pergamino_peso_muestra_oro_2 ?? 0);
                  const valorCriba = Number(getValues()?.analisis_oro?.zarandas?.[index]?.valor ?? 0);
                  const porcentaje = calcPorcentajeZaranda(valorCriba, pesoMuestraOro);
                  const etiqueta = getValues()?.analisis_oro?.zarandas?.[index]?.nombre_zaranda ?? 'Criba';
                  return porcentaje !== '' ? (
                    <span style={{ color: '#000000' }}>{`${etiqueta} (%) = ${porcentaje}`}</span>
                  ) : (
                    <span style={{ color: '#999' }}>{``}</span>
                  );
                })()}
              </div>
              <div className="col-xs-2 col-lg-1 mt-2">

            {index === 0 && (
              <div className="col-xs-6 col-xl-3 col-xxl-2">
                <button
                  className="btn btn-outline-dark mt-1"
                  type="button"
                  onClick={() => agregaZaranda()}
                >
                  <i className="fa fa-plus"></i>
                </button>
              </div>
            )}
              {index > 0 && (
              <div className="col-xs-6 col-xl-3 col-xxl-2">
                <button
                  className="btn btn-outline-danger mt-3"
                  type="button"
                  onClick={() => eliminaZaranda(index)}
                >
                  <i style={{color: 'red'}} className="fa fa-trash"></i>
                </button>
              </div>
              )}


              </div>
            </div>

          </div>


        </div>
        </div>
        ))}

    </div>
  );
};

export default CalidadAnalisisFisicoZarandas;
